import axiosHandler from '../axiosInterceptors';
import { USER_LOGOUT } from '../constants/urls';
import setAuthHeader from './AuthHeader';
import { logout } from '../authActions';
// Call the setAuthHeader function to set the Authorization header

export async function logoutUser(dispatch) {
    setAuthHeader();
    try{
        const resp = await axiosHandler.get(USER_LOGOUT);        
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem('session', 'inactive')
        dispatch(logout())
        return resp;
    }
    catch(error){   
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem('session', 'inactive')
        window.location.reload();
        throw error.response.data
    }
    
}